// ============================================================================
// GERMAN TRANSLATIONS - CHAPTER 5: DIE FRÜHE KIRCHE
// ============================================================================
// Levels 53-65 (13 Levels, 39 Fragen)

export const chapter5Translations = {
  name: "Die Frühe Kirche",
  description: "Ihr werdet Kraft empfangen...",
  
  spiritualWisdom: {
    principle: "Der Heilige Geist gibt Kraft und Mut zum Zeugnis",
    scripture: "Aber ihr werdet Kraft empfangen, wenn der Heilige Geist auf euch kommt, und werdet meine Zeugen sein (Apostelgeschichte 1:8)",
    application: "Die Kirche wird im Feuer des Geistes geboren und wächst durch mutiges Zeugnis"
  },
  
  levels: {
    53: {
      name: "Die Himmelfahrt",
      challenge: "Ihr werdet meine Zeugen sein... bis an die Enden der Erde...",
      easy: {
        question: "Wie viele Tage nach seiner Auferstehung fuhr Jesus in den Himmel auf?",
        options: ["30 Tage", "40 Tage", "50 Tage", "60 Tage"],
        hint: "Die biblische Zahl der Vorbereitung",
        funFact: "☁️ 40 Tage intensiver Lehre vor der weltweiten Mission!"
      },
      medium: {
        question: "Welches Versprechen gibt Jesus vor seiner Himmelfahrt?",
        options: [
          "Er wird bald wiederkommen",
          "Er wird den Heiligen Geist mit Kraft senden",
          "Er wird eine Kirche bauen",
          "Er wird die Bösen bestrafen"
        ],
        hint: "Eine Kraft von oben",
        funFact: "⚡ Verheißung des Heiligen Geistes - Verwandlung der ängstlichen Jünger!"
      },
      hard: {
        question: "Was symbolisiert die Himmelfahrt in unserem geistlichen Leben?",
        options: [
          "Das Ende der Gegenwart Jesu",
          "Jesus regiert und tritt für uns im Himmel ein",
          "Eine endgültige Trennung",
          "Ein symbolischer Mythos"
        ],
        hint: "Es geht um seine verherrlichte und aktive Gegenwart",
        funFact: "👑 Jesus regiert zur Rechten Gottes und tritt für uns ein!"
      }
    },
    
    54: {
      name: "Pfingsten",
      challenge: "Sie wurden alle vom Heiligen Geist erfüllt und begannen zu reden...",
      easy: {
        question: "Wie viele Tage nach der Himmelfahrt fand Pfingsten statt?",
        options: ["7 Tage", "10 Tage", "14 Tage", "20 Tage"],
        hint: "Etwa zehn Tage",
        funFact: "🔟 10 Tage intensives Gebet bereiten auf die Ausgießung des Geistes vor!"
      },
      medium: {
        question: "In welcher Form erschien der Heilige Geist?",
        options: [
          "Wie ein heftiger Wind",
          "Wie Feuerzungen",
          "Wie eine Taube",
          "Wie ein Licht"
        ],
        hint: "Flammen, die sich auf jeden Jünger setzen",
        funFact: "🔥 Feuerzungen: Der Geist gibt Mut und die Gabe der Sprachen!"
      },
      hard: {
        question: "Was bedeutet Pfingsten für die universale Kirche?",
        options: [
          "Ein isoliertes historisches Ereignis",
          "Die offizielle Geburt der missionarischen Kirche",
          "Ein Wunder aus Neugier",
          "Der Beginn der Feiern"
        ],
        hint: "Es geht um die Geburtsurkunde der Kirche",
        funFact: "🎂 Pfingsten = Geburtstag der Kirche, Beginn der weltweiten Mission!"
      }
    },

    55: {
      name: "Die erste Predigt des Petrus",
      challenge: "Was sollen wir tun, ihr Brüder? Tut Buße...",
      easy: {
        question: "Wie viele Menschen wurden nach der Predigt des Petrus getauft?",
        options: ["1000", "2000", "3000", "5000"],
        hint: "Dreitausend Seelen",
        funFact: "🌊 3000 Taufen an einem Tag - außergewöhnliches geistliches Erwachen!"
      },
      medium: {
        question: "Wessen beschuldigte Petrus die Menge?",
        options: [
          "Der Unwissenheit",
          "Jesus, den Messias, gekreuzigt zu haben",
          "Des Mangels an Glauben",
          "Der Heuchelei"
        ],
        hint: "Das höchste Verbrechen gegen den Sohn Gottes",
        funFact: "⚔️ Petrus, der Jesus verleugnete, verkündet nun seine Göttlichkeit!"
      },
      hard: {
        question: "Wie veranschaulicht die Verwandlung des Petrus das Werk des Heiligen Geistes?",
        options: [
          "Er wird gebildeter",
          "Von feige und wankelmütig wird er mutig und fest im Glauben",
          "Er erhält Kräfte",
          "Seine Persönlichkeit ändert sich"
        ],
        hint: "Es geht um die Heiligung durch den Geist",
        funFact: "🗿 Das 'schwankende Rohr' wird zum 'festen Fels' - verwandelnde Kraft!"
      }
    },

    56: {
      name: "Die erste Gemeinschaft",
      challenge: "Sie blieben beständig in der Lehre der Apostel und in der Gemeinschaft...",
      easy: {
        question: "Wie teilten die ersten Christen ihre Güter?",
        options: [
          "Jeder behielt seins",
          "Sie hatten alles gemeinsam",
          "Nur die Reichen gaben",
          "Durch gesetzliche Verpflichtung"
        ],
        hint: "Freiwillige Gütergemeinschaft",
        funFact: "🤝 Geschwisterliche Liebe so intensiv, dass sie spontan alles teilen!"
      },
      medium: {
        question: "Wofür verwendeten die ersten Christen ihre Zeit?",
        options: [
          "Nur für Geschäfte",
          "Lehre, Gemeinschaft, Brotbrechen, Gebete",
          "Nur für Arbeit",
          "Für Freizeit"
        ],
        hint: "Vier Säulen des Gemeinschaftslebens",
        funFact: "⛪ Lehre, Gemeinschaft, Eucharistie, Gebet - Fundamente der Kirche!"
      },
      hard: {
        question: "Warum war diese erste Gemeinschaft so attraktiv?",
        options: [
          "Sie war reich",
          "Authentische Liebe und Freude strahlten aus ihrer Einheit",
          "Sie versprach Wunder",
          "Sie kritisierte andere"
        ],
        hint: "Es geht um das Zeugnis gelebter Liebe",
        funFact: "✨ 'Seht, wie sie einander lieben!' - Zeugnis überzeugt mehr als Worte!"
      }
    },

    57: {
      name: "Die Heilung des Gelähmten",
      challenge: "Silber und Gold habe ich nicht; aber was ich habe, das gebe ich dir...",
      easy: {
        question: "Wie lange war der Mann schon gelähmt?",
        options: [
          "Seit 20 Jahren",
          "Seit 30 Jahren", 
          "Von Geburt an",
          "Seit 10 Jahren"
        ],
        hint: "Ein lebenslanges Gebrechen",
        funFact: "🚶 40 Jahre Gebrechen sofort im Namen Jesu geheilt!"
      },
      medium: {
        question: "In wessen Namen heilte Petrus den Gelähmten?",
        options: [
          "Im Namen Gottes",
          "Im Namen Jesu Christi von Nazareth",
          "In seinem eigenen Namen",
          "Im Namen Abrahams"
        ],
        hint: "Der Name über allen Namen",
        funFact: "✊ Der Name Jesu wirkt weiterhin Wunder durch die Apostel!"
      },
      hard: {
        question: "Was symbolisiert diese Heilung für das Evangelium?",
        options: [
          "Ein einfaches medizinisches Wunder",
          "Das vollständige Heil, das Jesus bringt: geistlich und körperlich",
          "Die Macht der Apostel",
          "Wohltätigkeit für die Armen"
        ],
        hint: "Es geht um das vollständige Heil des Menschen",
        funFact: "🩺 Jesus heilt Seele und Körper - vollständiges Heil der Person!"
      }
    },

    58: {
      name: "Die Verfolgung beginnt",
      challenge: "Man muss Gott mehr gehorchen als den Menschen...",
      easy: {
        question: "Wer verhaftete Petrus und Johannes nach der Heilung des Gelähmten?",
        options: [
          "Die Römer",
          "Die Sadduzäer und Priester",
          "Das Volk",
          "Pilatus"
        ],
        hint: "Die jüdischen religiösen Autoritäten",
        funFact: "⛓️ Erste religiöse Verfolgung - das Evangelium stört das Establishment!"
      },
      medium: {
        question: "Welches Verbot erließen die Autoritäten gegen die Apostel?",
        options: [
          "Jerusalem zu verlassen",
          "Nicht mehr im Namen Jesu zu lehren",
          "Keine Wunder mehr zu tun",
          "Nicht mehr zu beten"
        ],
        hint: "Verbot zu predigen",
        funFact: "🚫 Versuch, die Wahrheit zum Schweigen zu bringen - unmöglich, das Evangelium zu stoppen!"
      },
      hard: {
        question: "Wie reagierten die Apostel auf das Verbot?",
        options: [
          "Sie gehorchten aus Angst",
          "Sie bekräftigten, Gott mehr gehorchen zu müssen als den Menschen",
          "Sie verhandelten",
          "Sie flohen"
        ],
        hint: "Es geht um eine höhere Treue als menschliche Gesetze",
        funFact: "⚖️ Ziviler Ungehorsam, um Gott zu gehorchen - Mut der Überzeugung!"
      }
    },

    59: {
      name: "Ananias und Saphira",
      challenge: "Du hast nicht Menschen, sondern Gott belogen...",
      easy: {
        question: "Welche Lüge erzählten Ananias und Saphira?",
        options: [
          "Sie hatten nichts verkauft",
          "Sie gaben den ganzen Erlös, während sie einen Teil behielten",
          "Sie waren arm",
          "Sie waren nicht verheiratet"
        ],
        hint: "Lüge über den gegebenen Betrag",
        funFact: "💰 Einen Teil zu behalten war erlaubt, über die Gabe zu lügen nicht!"
      },
      medium: {
        question: "Was geschah mit ihnen nach ihrer Lüge?",
        options: [
          "Sie wurden vergeben",
          "Sie starben plötzlich",
          "Sie wurden ausgeschlossen",
          "Sie bereuten"
        ],
        hint: "Sofortige und strenge Bestrafung",
        funFact: "⚱️ Strenges Urteil zur Bewahrung der Reinheit der entstehenden Kirche!"
      },
      hard: {
        question: "Warum diese strenge Bestrafung am Anfang der Kirche?",
        options: [
          "Gott war grausam",
          "Um die erforderliche Heiligkeit in der Gemeinschaft zu etablieren",
          "Um Angst zu machen",
          "Durch Zufall"
        ],
        hint: "Es geht um die Bewahrung der geistlichen Integrität",
        funFact: "🔥 Hohe Standards am Anfang, um eine Kultur der Heiligkeit zu etablieren!"
      }
    },

    60: {
      name: "Die sieben Diakone",
      challenge: "Wählt aus eurer Mitte sieben Männer von gutem Ruf...",
      easy: {
        question: "Wie viele Diakone wurden gewählt?",
        options: ["5", "6", "7", "12"],
        hint: "Die Zahl der Vollkommenheit",
        funFact: "7️⃣ Sieben Diakone für den Dienst - göttliche Organisation der Kirche!"
      },
      medium: {
        question: "Was war ihre Hauptaufgabe?",
        options: [
          "Das Evangelium zu predigen",
          "Bei Tisch zu dienen und Witwen zu helfen",
          "Neue Bekehrte zu taufen",
          "Die Finanzen zu verwalten"
        ],
        hint: "Sozialer und materieller Dienst",
        funFact: "🍽️ Tischdienst = erste christliche Wohltätigkeitsorganisation!"
      },
      hard: {
        question: "Was offenbart diese Organisation über die christliche Vision des Dienstes?",
        options: [
          "Materielle Aufgaben sind minderwertig",
          "Geistlicher und materieller Dienst sind beide heilig",
          "Man muss das Heilige vom Profanen trennen",
          "Nur Priester dienen wirklich"
        ],
        hint: "Es geht um die Heiligkeit jedes Liebesdienstes",
        funFact: "✨ Tischdienst mit gleicher Würde wie Predigen - jeder Dienst ist heilig!"
      }
    },

    61: {
      name: "Stephanus, der erste Märtyrer",
      challenge: "Herr, rechne ihnen diese Sünde nicht zu! Und als er das gesagt hatte, entschlief er...",
      easy: {
        question: "Was war die Funktion des Stephanus in der Kirche?",
        options: ["Apostel", "Diakon", "Priester", "Prophet"],
        hint: "Einer der sieben zum Dienst Gewählten",
        funFact: "✨ Stephanus: Diakon wurde mächtiger Evangelist und erster Märtyrer!"
      },
      medium: {
        question: "Wessen beschuldigte Stephanus die jüdischen Führer?",
        options: [
          "Der Korruption",
          "Dem Heiligen Geist immer widerstanden zu haben",
          "Der Heuchelei",
          "Der Gier"
        ],
        hint: "Historischer Widerstand gegen Gott",
        funFact: "📜 Stephanus fasst die Geschichte zusammen: ständige Rebellion gegen Gott!"
      },
      hard: {
        question: "Wie starb Stephanus und was offenbart seine Haltung?",
        options: [
          "Im Zorn gegen seine Henker",
          "Vergebend wie Jesus am Kreuz",
          "In Verzweiflung",
          "Seine Feinde verfluchend"
        ],
        hint: "Es geht um die vollkommene Nachahmung Christi",
        funFact: "💝 Vergebung der Henker: Stephanus reproduziert perfekt die Haltung Jesu!"
      }
    },

    62: {
      name: "Philippus und der äthiopische Eunuch",
      challenge: "Wie könnte ich verstehen, wenn mich niemand anleitet?",
      easy: {
        question: "Was las der Eunuch in seinem Wagen?",
        options: [
          "Die Psalmen",
          "Den Propheten Jesaja",
          "Die Genesis",
          "Die Sprüche"
        ],
        hint: "Der Prophet der Passion des Messias",
        funFact: "📖 Jesaja 53 - perfekte Prophezeiung über Jesus von aufrichtigem Sucher gelesen!"
      },
      medium: {
        question: "Wie erklärte Philippus die Jesaja-Passage?",
        options: [
          "Er sprach über alte Geschichte",
          "Er verkündigte Jesus ausgehend von diesem Text",
          "Er gab eine Theologie-Lektion",
          "Er kritisierte Interpretationen"
        ],
        hint: "Die Schrift führt natürlich zu Christus",
        funFact: "✝️ Die ganze Schrift konvergiert zu Jesus - Schlüssel zum Verständnis!"
      },
      hard: {
        question: "Was symbolisiert die Bekehrung des äthiopischen Eunuchen?",
        options: [
          "Eine isolierte Bekehrung",
          "Die Universalität des Evangeliums für alle Rassen und Stände",
          "Die Überlegenheit bestimmter Völker",
          "Ein Sonderfall"
        ],
        hint: "Es geht um die Öffnung für die Nationen",
        funFact: "🌍 Äthiopier, Eunuch, Minister: Das Evangelium durchbricht alle Barrieren!"
      }
    },

    63: {
      name: "Die Bekehrung des Saulus von Tarsus",
      challenge: "Saul, Saul, warum verfolgst du mich?",
      easy: {
        question: "Was tat Saulus vor seiner Bekehrung?",
        options: [
          "Er predigte das Evangelium",
          "Er verfolgte die Christen",
          "Er war neutral",
          "Er studierte nur"
        ],
        hint: "Erbitterter Feind der Jünger",
        funFact: "⚔️ Saulus schnaubte Drohung und Mord gegen die Jünger Jesu!"
      },
      medium: {
        question: "Auf welchem Weg erschien Jesus dem Saulus?",
        options: [
          "Der Weg nach Jerusalem",
          "Der Weg nach Damaskus",
          "Der Weg nach Gaza",
          "Der Weg nach Antiochia"
        ],
        hint: "Eine Stadt in Syrien",
        funFact: "🛤️ Damaskusweg = berühmtester Ort der Verwandlung in der Geschichte!"
      },
      hard: {
        question: "Wie veranschaulicht diese Bekehrung die göttliche Gnade?",
        options: [
          "Gott bekehrt nur die Guten",
          "Die Gnade kann den schlimmsten Feind in den größten Apostel verwandeln",
          "Die Bekehrung war verdient",
          "Saulus war Gott bereits nahe"
        ],
        hint: "Es geht um die verwandelnde Kraft der Gnade",
        funFact: "⚡ Vom größten Verfolger zum größten Missionar - Wunder der Gnade!"
      }
    },

    64: {
      name: "Petrus und Kornelius",
      challenge: "Nun erfahre ich in Wahrheit, dass Gott die Person nicht ansieht...",
      easy: {
        question: "Was war der Beruf des Kornelius?",
        options: [
          "Händler",
          "Römischer Hauptmann",
          "Priester",
          "Schriftgelehrter"
        ],
        hint: "Offizier der römischen Armee",
        funFact: "🎖️ Erster offiziell bekehrter Heide - Öffnung für Nichtjuden!"
      },
      medium: {
        question: "Welche Vision hatte Petrus vor dem Treffen mit Kornelius?",
        options: [
          "Ein Engel sprach zu ihm",
          "Ein Tuch mit reinen und unreinen Tieren",
          "Jesus erschien ihm",
          "Ein zerstörter Tempel"
        ],
        hint: "Vision über Reinheit und Unreinheit",
        funFact: "🕊️ Tuch mit Tieren: Gott hebt Speise- und Rassenunterscheidungen auf!"
      },
      hard: {
        question: "Welches revolutionäre Prinzip etablierte diese Bekehrung?",
        options: [
          "Die Römer sind überlegen",
          "Gott sieht die Person nicht an - universales Heil",
          "Man muss Traditionen aufgeben",
          "Die Beschneidung ist nutzlos"
        ],
        hint: "Es geht um die Universalität des Heils",
        funFact: "🌍 Geistliche Revolution: Das Evangelium ist für alle Völker ohne Ausnahme!"
      }
    },

    65: {
      name: "Die Kirche von Antiochia",
      challenge: "In Antiochia wurden die Jünger zuerst Christen genannt...",
      easy: {
        question: "Wie wurden die Jünger zum ersten Mal in Antiochia genannt?",
        options: ["Jünger", "Christen", "Gläubige", "Heilige"],
        hint: "Der Name, den wir heute noch tragen",
        funFact: "✝️ 'Christen' = 'kleine Christi' - Ehrenname von Heiden gegeben!"
      },
      medium: {
        question: "Wer kam mit Barnabas nach Antiochia zum Lehren?",
        options: [
          "Petrus",
          "Paulus (Saulus)",
          "Jakobus",
          "Johannes"
        ],
        hint: "Der ehemalige Verfolger wurde Apostel",
        funFact: "👥 Barnabas sucht Paulus in Tarsus - Beginn des paulinischen Dienstes!"
      },
      hard: {
        question: "Warum wurde Antiochia in der christlichen Geschichte so wichtig?",
        options: [
          "Es war reich",
          "Erstes Missionszentrum für die Heiden",
          "Es war gut gelegen",
          "Es hatte gute Führer"
        ],
        hint: "Es geht um die missionarische Expansion",
        funFact: "🚢 Antiochia: Starthafen aller Missionsreisen des Paulus nach Europa!"
      }
    }
  }
};

export default chapter5Translations;
